// Core
import React from "react"
import styled from "styled-components"

// General components
import Title from "../../../../../../components/Title"
import Paragraph from "../../../../../../components/Paragraph"

// Style
import size from "../../../../../../styles/size"

const Container = styled.div`
  width: 100%;
  max-width: 500px;

  p {
    margin-top: 3rem;
  }

  @media (max-width: ${size.laptop}) {
    margin-top: 6rem;
  }
`

export default function CopyContainer() {
  return (
    <Container>
      <Title darkBG>Nossa liderança</Title>

      <Paragraph darkBG>
        Pr. Sinval de Souza e Pra. Rosália Santt estão casados desde 1990 e são
        pais de dois filhos, Robert de Souza e Aline Lorrany.
      </Paragraph>
      <Paragraph darkBG>
        Desde 2001 estão à frente da nossa igreja por amor e obediência à voz de
        Deus.
      </Paragraph>
      <Paragraph darkBG>
        Com uma trajetória ministerial marcada por conquistas e milagres,
        compreendem que família é a forma que Deus escolheu para sermos uma
        igreja dinâmica, contemporânea, feita de pessoas para pessoas, em
        constante transformação e que não negocia a verdade bíblica.
      </Paragraph>
    </Container>
  )
}
